import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BaseSelectService<T> {
  value!: T;
  subject = new BehaviorSubject(this.value);
  setValue(value: T) {
    //here notify all subscribers about the new value
    this.subject.next(value);
  }
  getValue(): Observable<T> {
    //here return an observable to subscribe to value changes
    return this.subject.asObservable();
  }
}
